import { internal, template } from '../../vendor/elix.js';
import FilledInputMixin from './filled-input-mixin.js';

function FilledInputLightMixin(Base) {

  return class FilledInputLight extends FilledInputMixin(Base) {

    get [internal.template]() {

      const innerSelector = this.innerSelector || '#inner';

      return template.concat(

        super[internal.template],

        template.html`

          <style>

            ${innerSelector} {
              background-color: var(--tp-filled-input-mixin-light-background-color);
            }

            .inputStateContainer.disabled ${innerSelector} {
              background-color: var(--tp-filled-input-mixin-light-background-color-disabled);
            }

            .inputStateContainer:not(.disabled):not(.error):hover ${innerSelector}:not(:focus) {
              background-color: var(--tp-filled-input-mixin-light-background-color-hover);
            }

            .inputStateContainer:not(.disabled) ${innerSelector}:focus,
            .inputStateContainer:not(.disabled) ${innerSelector}:active {
              background-color: var(--tp-filled-input-mixin-light-background-color-focused);
            }

            </style>
        `
      );

    }

  }

}

export default FilledInputLightMixin;
